import React, { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import './ParticipantHover.css';

const ParticipantHover = ({ participants, participantCount }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const containerRef = useRef(null);

  // Calculate tooltip position when hovering
  const handleMouseEnter = () => {
    if (containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect();
      setTooltipPosition({
        top: rect.bottom + 8,
        left: rect.left + rect.width / 2
      });
    }
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  // If no participants data, don't render the hover component
  if (!participants || participants.length === 0) {
    return (
      <span className="participant-count">
        <i className="ti ti-users"></i>
        {participantCount || 0} participants
      </span>
    );
  }

  // Render tooltip using portal to document body
  const renderTooltip = () => {
    if (!isHovered) return null;

    return createPortal(
      <div 
        className="participant-tooltip"
        style={{
          position: 'fixed',
          top: tooltipPosition.top,
          left: tooltipPosition.left,
          transform: 'translateX(-50%)',
          zIndex: 999999
        }}
      >
        <div className="tooltip-header">
          <i className="ti ti-users"></i>
          <span>Meeting Participants</span>
        </div>
        <div className="participant-list">
          {participants.map((participant, index) => (
            <div key={index} className="participant-item">
                              <div className="participant-avatar">
                  <span className="participant-initial">
                    {(participant.user_id || participant.name) ? (participant.user_id || participant.name).charAt(0).toUpperCase() : 'U'}
                  </span>
                </div>
                              <div className="participant-details">
                  <div className="participant-name">
                    {participant.user_id || participant.name || participant.email || `Participant ${index + 1}`}
                  </div>
                  {participant.email && participant.email !== participant.user_id && participant.email !== participant.name && (
                    <div className="participant-email">
                      {participant.email}
                    </div>
                  )}
                  {participant.role && (
                    <div className="participant-role">
                      {participant.role}
                    </div>
                  )}
                </div>
            </div>
          ))}
        </div>
      </div>,
      document.body
    );
  };

  return (
    <>
      <div 
        ref={containerRef}
        className="participant-hover-container"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <span className="participant-count">
          <i className="ti ti-users"></i>
          {participantCount || participants.length} participants
        </span>
      </div>
      
      {renderTooltip()}
    </>
  );
};

export default ParticipantHover; 